import { UsuaPerfilAtivo, Usuario } from "../interfaces/user";
import { CommunicationService } from "../services/communication.service";
// @ts-ignore
import { AuthService, LocalStorageService, APPS as APP_INFO} from "@cosmos/utilities";
import * as singleSpa from "single-spa";

export class ChangeUserProfileEvent {
  readonly EVENT_NAME = "requestChangeUserProfile";
  static changeUserProfile;

  private constructor() {
    this.load();
  }

  static init(): ChangeUserProfileEvent {
    if (!ChangeUserProfileEvent.changeUserProfile) {
      ChangeUserProfileEvent.changeUserProfile = new ChangeUserProfileEvent();
    }
    return ChangeUserProfileEvent.changeUserProfile;
  }

  load() {
    const communicationService = CommunicationService.singleton();
    communicationService.receiveCustomEvent(
      this.EVENT_NAME,
      this.requestChangeUserProfile
    );
  }

  destroy() {
    const communicationService = CommunicationService.singleton();
    communicationService.removeEventListener(
      this.EVENT_NAME,
      this.requestChangeUserProfile
    );
  }

  requestChangeUserProfile: EventListener = async (event: CustomEvent) => {
    const authService = new AuthService();
    const communicationService = CommunicationService.singleton();
    const localStorageService = LocalStorageService.singleton();

    const token = localStorageService.getItem("token");
    const sistAtivoToken: string =
      localStorageService.getSystemAtivoToken("sist_ativo_token");
    const instCodigo = event.detail.inst_codigo;
    const usuaTipoId = event.detail.usua_tipo_id;

    try {
      const userProfileReq = await authService.userProfile({
        token,
        chave_sistema: sistAtivoToken,
        inst_codigo: instCodigo,
        usua_tipo_id: usuaTipoId,
      });

      const userProfileData: UsuaPerfilAtivo = userProfileReq.data.data;
      localStorageService.setItem("usua_perfil_ativo", userProfileData);
      localStorageService.setSystemAtivoToken(sistAtivoToken);

      const userProfile: UsuaPerfilAtivo = userProfileReq.data.data.usua_perfil_ativo;
      localStorageService.setItem("usua_perfil_ativo", userProfile);

      const userData: Usuario = userProfileReq.data.data.usuario;
      localStorageService.setItem("usuario", userData);

      this.remountSistAtual(sistAtivoToken);
      communicationService.emitCustomEvent("changeUserProfile", userProfile);
    } catch (error) {
      console.log(error);
      communicationService.emitCustomEvent("changeUserProfile", false);
    }
  };

  remountSistAtual(sistAtivoToken: string) {
    const sistDestino: AppInfoDetails = Object.values(APP_INFO).find(
      (app: AppInfoDetails) =>
        app.sspa_name && app.chave_sistema == sistAtivoToken
    ) as AppInfoDetails;

    if (sistDestino) {
      singleSpa.unloadApplication(sistDestino.sspa_name);
    }
  }
}
